import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import xss from 'xss';

import Link from '~/components/Link/Link';
// import FourThirdCard from '~/components/Card/FourThirdCard';
// import LxCard from '~/components/Card/LxCard';
// import ArticleCard from '~/components/Card/ArticleCard';
import Colors from '~/utils/colors';
import { stripLink } from '~/utils/helpers';

const FourThirdCard = dynamic(() => import(/* webpackChunkName: "Card.FourThirdCard.components" */'../Card/FourThirdCard'), { loading: () => null });
const LxCard = dynamic(() => import(/* webpackChunkName: "Card.LxCard.components" */'../Card/LxCard'), { loading: () => null });
const ArticleCard = dynamic(() => import(/* webpackChunkName: "Card.ArticleCard.components" */'../Card/ArticleCard'), { loading: () => null });

const Header = styled.h2`
  font-weight: 500;
  font-size: 24px;
  margin: 18px 0;
  @media(max-width: 700px) {
    font-size: 18px;
  }
`;

const HeaderSeeAll = styled.span`
  font-weight: 300;
  font-size: 18px;
  color: ${Colors.lightGray};
  display: inline-block;
  white-space: nowrap; 
  cursor: pointer;
  @media(max-width: 700px) {
    font-size: 15px;
  }
`;

const TopicName = styled.span`
  display: inline-block;
`;

const FloatParent = styled.div`
  ${props => props.isMargin && 'margin: 30px 0px;'}
  &::after {
    content: " ";
    display: block; 
    height: 0; 
    clear: both;
  }
`;

const FloatItem = styled.div`
  box-sizing: border-box;
  width: ${props => (props.isVertical ? '730px' : '25%')};
  ${props => (props.isVertical ? 'margin: 0 auto;' : 'float: left;')}
  margin-bottom: 20px;

  @media (max-width: 700px) {
    width: 100%;
  }
  ${props => !props.isVertical && `
    &:nth-child(4n+1) {
      clear: both;
      @media (min-width: 701px) {
        padding-right: 6.67px;
      }
    }
    &:nth-child(4n+2), &:nth-child(4n+3) {
      @media (min-width: 701px) {
        padding-left: 3.33px;
        padding-right: 3.33px;
      }
    }
    &:nth-child(4n+4) {
      @media (min-width: 701px) {
        padding-left: 6.67px;
      }
    }
  `}
`;

class CardTopic extends Component {
  static propTypes = {
    name: PropTypes.string,
    contains: PropTypes.string,
    fullPath: PropTypes.string,
    objects: PropTypes.any,
    seeAll: PropTypes.string,
    isOmitTitle: PropTypes.bool,
    logClickCard: PropTypes.func,
    logClickSeeMore: PropTypes.func,
    logImpressCard: PropTypes.func,
    _id: PropTypes.string,
    index: PropTypes.number,
    inspiration_style: PropTypes.bool,
    addToConversionSource: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { objects } = props;
    const cardImpressed = {};
    if (Array.isArray(objects)) {
      objects.forEach((obj, index) => { cardImpressed[`card-${index}`] = false; });
    }
    this.cardImpressed = cardImpressed;
  }

  componentDidMount() {
    if (this.root) {
      this.interval = setInterval(() => {
        const rect = this.root.getBoundingClientRect();
        const elemCenter = rect.top + 60;
        if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
          this.impressCard();
        }
      }, 1000);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  impressCard() {
    if (!this.props.logImpressCard) return;
    const cardImpressed = { ...this.cardImpressed };
    this.props.objects.map((obj, index) => {
      const elem = this[`card-${index}`];
      if (!elem || cardImpressed[`card-${index}`]) return null;
      const rect = elem.getBoundingClientRect();
      const elemCenter = (rect.top + rect.bottom * 2) / 3; // eslint-disable-line
      const container = window.innerHeight;
      if (elemCenter < container && rect.bottom >= 60) {
        const { objects } = this.props;
        this.props.logImpressCard({
          id: objects[index] && objects[index]._id,
          name: objects[index] && objects[index].name,
          slug: objects[index] && objects[index].slug,
          index,
          parent: {
            type: this.props.contains,
            name: this.props.name,
            id: this.props._id,
            index: this.props.index
          },
        });
        cardImpressed[`card-${index}`] = true;
      }
      return null;
    });
    if (!Object.keys(cardImpressed).some(key => cardImpressed[key] === false)) {
      clearInterval(this.interval);
    }
    this.cardImpressed = cardImpressed;
  }

  clickCard(index) {
    const { objects } = this.props;
    if (!!this.props.addToConversionSource && this.props.contains === 'trips') {
      this.props.addToConversionSource(`topic-${this.props.contains}`, objects[index]._id, this.props._id);
    }
    if (this.props.logClickCard) {
      this.props.logClickCard({
        id: objects[index] && objects[index]._id,
        name: objects[index] && objects[index].name,
        slug: objects[index] && objects[index].slug,
        index,
        parent: {
          id: this.props._id,
          type: this.props.contains,
          name: this.props.name,
          index: this.props.index
        },
      });
    }
  }

  logSeeMore(card = false) {
    if (!this.props.logClickSeeMore) return;
    this.props.logClickSeeMore({
      type: this.props.contains,
      name: this.props.name,
      id: this.props._id,
      card,
    });
  }

  render() {
    const {
      name,
      objects,
      alignment,
      seeAll,
      contains,
      isOmitTitle,
      fullPath,
    } = this.props;
    if (!objects || objects.length === 0) {
      return <div />;
    }
    return (
      <div
        ref={c => {
          this.root = c;
        }}
        style={contains === 'availableTrips' ? { position: 'relative' } : {}}
      >
        <Header
          style={(isOmitTitle && { display: 'none' }) || null}
        >
          <TopicName
            style={(seeAll && { marginRight: '10px' }) || null}
            dangerouslySetInnerHTML={{ __html: xss(fullPath ? stripLink(name, fullPath) : name) }}
          />
          {seeAll && (
            <Link to={seeAll}>
              <HeaderSeeAll onClick={() => this.logSeeMore()} className="header-see-all">(See more)</HeaderSeeAll>
            </Link>
          )}
        </Header>
        <FloatParent isMargin={alignment === 'vertical'}>
          {objects.map((obj, index) => (
            <FloatItem
              key={`${contains}-${index}`}
              ref={c => {
                this[`card-${index}`] = c;
              }}
              isVertical={alignment === 'vertical'}
              onClick={() => this.clickCard(index)}
            >
              {(() => {
                if (contains === 'trips') {
                  return <FourThirdCard data={obj} alignment={alignment} ranking={index + 1} />;
                }
                if (contains === 'users') {
                  return <LxCard data={obj} />;
                }
                if (contains === 'articles') {
                  return <ArticleCard data={obj} inspirationStyle={this.props.inspiration_style} />;
                }
                return <div />;
              })()}
            </FloatItem>
          ))}
        </FloatParent>
      </div>
    );
  }
}

export default CardTopic;
